// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3osGs","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2-dw_"};